import React, { useState } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { ArrowLeftIcon, ArrowRightIcon } from './PropertyIcons';

const testimonials = [
  {
    id: 1,
    rating: 5,
    title: 'Exceptional Service!',
    description: 'Our experience with AlkinaRealty was outstanding. Their team\'s dedication and professionalism made finding our dream home a breeze. Highly recommended!',
    name: 'Wade Warren',
    location: 'USA, California',
    avatarUrl: '/testimonila_1.jpg',
  },
  {
    id: 2,
    rating: 5,
    title: 'Efficient and Reliable',
    description: 'AlkinaRealty provided us with top-notch service. They helped us sell our property quickly and at a great price. We couldn\'t be happier with the results.',
    name: 'Emelie Thomson',
    location: 'USA, Florida',
    avatarUrl: '/testimonila_2.jpg',
  },
  {
    id: 3,
    rating: 5,
    title: 'Trusted Advisors',
    description: 'The AlkinaRealty team guided us through the entire buying process. Their knowledge and commitment to our needs were impressive. Thank you for your support!',
    name: 'John Mans',
    location: 'USA, Nevada',
    avatarUrl: '/testimonila_3.jpg',
  },
];

export const Testimonials: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 10;

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(1, prev - 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(totalPages, prev + 1));
  };

  return (
    <div className="w-full bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20">
      <div className="max-w-6xl mx-auto flex flex-col gap-12 lg:gap-16">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end gap-4 lg:gap-16">
          <div className="flex-1 flex flex-col gap-2">
            <div className="relative">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%] text-primary">
                What Our Clients Say
              </h1>
            </div>
            <p className="text-sm md:text-base font-normal leading-[150%] text-black">
              Read the success stories and heartfelt testimonials from our valued clients. Discover why they chose Alkina Realty for their real estate needs.
            </p>
          </div>
          
          <button className="px-4 py-2.5 border border-[var(--color-primary)] bg-[var(--color-primary)] hover:bg-[var(--color-primary)]/90 hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 whitespace-nowrap">
            <span className="text-sm font-medium leading-[150%] text-white">
              View All Testimonials
            </span>
          </button>
        </div>

        {/* Cards Grid */}
        <div className="flex flex-col gap-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-6">
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} {...testimonial} />
            ))}
          </div>

          {/* Pagination */}
          <div className="flex items-center justify-between pt-3 border-t border-gray-300">
            <div className="text-sm md:text-base font-medium leading-[150%]">
              <span className="text-primary">{String(currentPage).padStart(2, '0')}</span>
              <span className="text-primary"> of {String(totalPages).padStart(2, '0')}</span>
            </div>

            <div className="flex items-center gap-2">
              {/* Previous Button */}
              <button
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className="p-1.5 md:p-2 border border-gray-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                aria-label="Previous page"
              >
                <ArrowLeftIcon className="w-4 h-4 md:w-6 md:h-6" />
              </button>

              {/* Next Button */}
              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className="p-1.5 md:p-2 border border-gray-300 bg-gray-100 hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                aria-label="Next page"
              >
                <ArrowRightIcon className="w-4 h-4 md:w-6 md:h-6" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


